<template>
  <div class="page">
    <div class="pgae_bg ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="0.8s">
      <p class="title ani" swiper-animate-effect="fadeInDown"
      swiper-animate-duration="1s"
      swiper-animate-delay="0.25s">大象新闻客户端两周年宠粉节</p>
      <img class="logo ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.2s" src="./../../common/imgs/car/car_logo.png" alt="">
      <img class="text ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.3s" src="./../../common/imgs/car/car_txt.png" alt="">
      <img class="icon01 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="0.9s" src="./../../common/imgs/car/car_icon18.png" alt="">
      <img class="icon02 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1s" src="./../../common/imgs/car/car_icon17.png" alt="">
      <!-- 左边 -->
      <div class="car_left">
        <img class="icon04 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.4s" src="./../../common/imgs/car/car_icon01.png" alt="">
        <img class="icon05 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.5s" src="./../../common/imgs/car/car_icon02.png" alt="">
        <img class="icon06 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.6s" src="./../../common/imgs/car/car_icon03.png" alt="">
        <img class="icon07 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.7s" src="./../../common/imgs/car/car_icon04.png" alt="">
        <img class="icon08 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.8s" src="./../../common/imgs/car/car_icon05.png" alt="">
        <img class="icon09 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.9s" src="./../../common/imgs/car/car_icon06.png" alt="">
        <img class="icon10 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2s" src="./../../common/imgs/car/car_icon07.png" alt="">
        <img class="icon11 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.1s" src="./../../common/imgs/car/car_icon08.png" alt="">
      </div>
      <!-- 右边 -->
      <div class="car_right">
        <img class="icon12 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.2s" src="./../../common/imgs/car/car_icon09.png">
        <img class="icon13 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.3s" src="./../../common/imgs/car/car_icon10.png">
        <img class="icon15 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.4s" src="./../../common/imgs/car/car_icon12.png">
        <img class="icon14 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.5s" src="./../../common/imgs/car/car_icon11.png">
        <img class="icon16 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.6s" src="./../../common/imgs/car/car_icon13.png">
        <img class="icon17 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.7s" src="./../../common/imgs/car/car_icon14.png">
        <img class="icon18 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="2.8s" src="./../../common/imgs/car/car_icon15.png">
      </div>
    </div>
      <img class="icon03 ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="1.1s" src="./../../common/imgs/car/car_icon16.png" alt="">
      <img class="box ani" swiper-animate-effect="fadeIn"
      swiper-animate-duration="1s"
      swiper-animate-delay="0.2s" src="./../../common/imgs/car/car_box.png" alt="">
      <img class="car ani" swiper-animate-effect="fadeInRight"
      swiper-animate-duration="1s"
      swiper-animate-delay="0.6s" src="./../../common/imgs/car/car.png" alt="">
  </div>
</template>
<script>
  export default {
    name:"item01",
    methods:{
      startAnimation() {
        
      }
    }
  }
</script>

<style lang="scss" scoped>
@import 'common/scss/wap/mixin.scss';
.page {
  position: relative;
  @include bg('./../../common/imgs/car/car_bg.png');
  .pgae_bg {
    position: relative;
    width: 750px;
    height: 1026px;
    background-image: url('./../../common/imgs/car/car_bg1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .title {
      @include titleColor(#FEFEFF);
    }
    .logo {
      display: block;
      width: 196px;
      height: 232px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .text {
      display: block;
      width: 265px;
      height: 347px;
      margin-top: 20px;
      margin-left: 272px;
    }
    .icon01 {
      position: absolute;
      right: 300px;
      bottom: 120px;
      width: 197px;
      height: 166px;
    }
    .icon02 {
      position: absolute;
      left: 180px;
      bottom: 120px;
      width: 128px;
      height: 161px;
    }
    .car_left {
      position: absolute;
      left: 0;
      top: 0;
      img {
        display: block;
      }
      .icon04 {
        width: 58px;
        height: 74px;
        margin-top: 197px;
      }
      .icon05 {
        width: 101px;
        height: 122px;
        margin-left: 46px;
      }
      .icon06 {
        width: 39px;
        height: 39px;
        margin-left: 7px;
      }
      .icon07{
        width: 90px;
        height: 109px;
        margin-top: -40px;
        margin-left: 150px;
      }
      .icon08{
        width: 99px;
        height: 66px;
        margin-top: -40px;
        margin-left: 34px;
      }
      .icon09{
        width: 61px;
        height: 54px;
        margin-top: 50px;
        margin-left: 60px;
      }
      .icon10 {
        width: 114px;
        height: 89px;
        margin-top: -100px;
        margin-left: 140px;
      }
      .icon11 {
        width: 57px;
        height: 83px;
        margin-left: 180px;
        margin-top: 30px;
      }
    }
    .car_right {
      position: absolute;
      top: 70px;
      right: 0;
      img {
        display: block;
      }
      .icon12 {
        width: 101px;
        height: 50px;
        margin-right: 70px;
        margin-top: 40px;
      }
      .icon13 {
        width: 58px;
        height: 58px;
        margin-left: 80px;
      }
      .icon14 {
        display: inline-block;
        width: 63px;
        height: 74px;
        margin-left: 10px;
        margin-top: 20px;
      }
      .icon15 {
        display: inline-block;
        width: 85px;
        height: 83px;
        
      }
      .icon16 {
        width: 75px;
        height: 62px;
        margin-top: 50px;
        margin-left: 30px;
      }
      .icon17 {
        width: 123px;
        height: 112px;
        margin-top: 40px;
      }
      .icon18 {
        width: 105px;
        height: 99px;
        margin-top: 20px;
        margin-left: -60px;
      }
    }
  }
  .icon03 {
    position: absolute;
    left: 20px;
    bottom: 300px;
    width: 128px;
    height: 135px;
  }
  .box {
    position: absolute;
    bottom: 80px;
    width: 698px;
    height: 453px;
  }
  .car {
    position: absolute;
    right: 0;
    width: 687px;
    height: 279px;
  }
}
</style>